/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileBookmark32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none">
            <path
                fill={vars.bdlGray20}
                d="M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill={vars.white}
                fillOpacity={0.5}
                d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            />
            <path
                fill={vars.bdlGray80}
                d="M16.488 21.04c.242-.243.523-.3.772-.065.25.237.177.53-.065.773l-.745.745c-1.376 1.376-3.538 1.2-4.841-.109-1.294-1.299-1.48-3.46-.12-4.818l.735-.737c.242-.243.551-.34.8-.103.25.236.17.537-.073.78l-.736.737c-.958.961-.93 2.4.1 3.434 1.032 1.035 2.48 1.059 3.404.133l.769-.77zm1.557-1.557l.77-.77c.926-.922.901-2.37-.133-3.402-1.035-1.03-2.473-1.059-3.434-.101l-.737.736c-.243.242-.545.324-.78.074-.237-.25-.14-.558.102-.8l.738-.735c1.358-1.36 3.519-1.175 4.818.12 1.308 1.302 1.485 3.464.108 4.84l-.745.745c-.243.243-.536.315-.772.065s-.178-.53.065-.772zm-3.518.695c-.244.244-.6.282-.794.087-.196-.195-.157-.55.087-.794l2.654-2.654c.243-.244.599-.283.794-.087.195.195.156.55-.087.794l-2.654 2.654z"
            />
        </g>
    </AccessibleSVG>
);

export default FileBookmark32;
